import { Segment } from '@fixter/i18n';

export const DEFAULT_SEGMENT = Segment.Fixter_UK;
